export default __webpack_public_path__ + "static/media/albama.58ac7e27.png";